import { useState } from 'react';
import './style.scss';
import { FormError } from 'views/mutual/formErrorScroll';

export enum MaskType {
  Start = 1,
  End,
}

export type MaskAttr = {
  type: MaskType;
  displayedCount: number;
};

type EstablishTextProps = {
  textareaType: string;
  textareaValue?: string;
  setTextareaValue?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyEnter?: () => void;
  placeholder?: string;
  disabled?: boolean;
  masked?: MaskAttr;
};

const mask = (target: String | undefined, attr: MaskAttr) => {
  if (!target) return '';

  switch (attr.type) {
    case MaskType.Start: {
      const visible = target.slice(-1 * attr.displayedCount);
      return visible.padStart(target.length, '*');
    }
    case MaskType.End: {
      const visible = target.slice(0, attr.displayedCount);
      return visible.padEnd(target.length, '*');
    }
  }
};

export type TextareaTemplateDataProps = {
  value?: string;
  error?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  maxLength?: number;
  masked?: MaskAttr;
};

export type TextareaTemplateProps = {
  type?: string;
  placeholder?: string;
} & TextareaTemplateDataProps;

export const TextareaTemplate = (props: TextareaTemplateProps) => {
  const { type, value, placeholder, disabled, error, onChange, maxLength, masked } = props;
  const [hide, setHide] = useState<boolean>(true);

  return (
    <>
      <div className="textareaTemplate">
        <textarea
          className="textareaTemplate_textarea"
          value={masked && hide ? mask(value, masked) : value}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(e) => onChange && onChange(e.target.value)}
          onFocus={() => setHide(false)}
          maxLength={maxLength}
        />
        <FormError className="textareaTemplate_error" error={error} />
      </div>
    </>
  );
};
